/**
 * Application entry point (Vite). Mounts <App /> into the #root DOM node,
 * wrapped in React.StrictMode, UserProvider (contexts/UserContext) and BrowserRouter.
 * Also logs window.RUNTIME_CONFIG (injected by public/config/config.js) on page load.
 * Note: UserProvider is applied again inside App.tsx, so it is nested twice.
 */
import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { UserProvider } from "@/contexts/UserContext";
import { BrowserRouter } from "react-router-dom";

// Print the runtime configuration on each page load
console.log("Runtime configuration:", window.RUNTIME_CONFIG);

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <UserProvider>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </UserProvider>
    </React.StrictMode>
);
